import type { SVGProps } from 'react';

export function FillEnvelopeIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M18.25 8.11929V14.3746C18.25 14.905 18.0393 15.4138 17.6642 15.7888C17.2891 16.1639 16.7804 16.3746 16.25 16.3746H3.75C3.21957 16.3746 2.71086 16.1639 2.33579 15.7888L1.98223 16.1424L2.33579 15.7888C1.96071 15.4137 1.75 14.905 1.75 14.3746V8.11929L8.42799 12.228L8.428 12.228C8.90076 12.5188 9.44494 12.6728 10 12.6728C10.5551 12.6728 11.0992 12.5188 11.572 12.228L11.572 12.228L18.25 8.11929Z'
        fill='currentColor'
        stroke='currentColor'
      />
      <path
        d='M18.75 5.75667V5.625C18.75 4.96196 18.4866 4.32607 18.0178 3.85723C17.5489 3.38839 16.913 3.125 16.25 3.125H3.75C3.08696 3.125 2.45107 3.38839 1.98223 3.85723C1.51339 4.32607 1.25 4.96196 1.25 5.625V5.75667L9.345 10.7383C9.54198 10.8595 9.76872 10.9237 10 10.9237C10.2313 10.9237 10.458 10.8595 10.655 10.7383L18.75 5.75667Z'
        fill='currentColor'
      />
    </svg>
  );
}
